import { Button, Modal } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import { useTranslation } from '@/i18n/client';

import styles from './index.less';

// Defined outside component to avoid re-creation on every render
const stopPropagationModalRender = (node: ReactNode) => (
  <div onClick={(e) => e.stopPropagation()}>{node}</div>
);

function BlockModal(props: {
  open: boolean;
  setOpen: (state: boolean) => void;
  onBlock: () => void;
}): JSX.Element {
  const { open, setOpen, onBlock } = props;
  const { t } = useTranslation();

  return (
    <Modal
      centered={true}
      className={styles.blockModal}
      footer={null}
      modalRender={stopPropagationModalRender}
      onCancel={() => setOpen(false)}
      open={open}
    >
      <div className={styles.blockModalTitle}>{t('homepage.settingModal.block')}</div>
      <div className={styles.blockModalDescription}>
        {t('homepage.settingModal.blockDescription')}
      </div>
      <div className={styles.blockModalActions}>
        <Button className={styles.cancelButton} onClick={() => setOpen(false)}>
          {t('homepage.settingModal.cancel')}
        </Button>
        <Button
          className={classNames(styles.confirmButton)}
          onClick={() => {
            setOpen(false);
            onBlock();
          }}
        >
          {t('common.confirm')}
        </Button>
      </div>
    </Modal>
  );
}

export default BlockModal;
